export const ProductTypeEnum = [
    { id: 'simple', name: 'Simple' },
    { id: 'configurable', name: 'Configurable' },
    { id: 'bundle', name: 'Bundle' },
];